import React from "react";
import ComingSoonPanel from "../components/ComingSoonPanel";

const PromotionPage: React.FC = () => {
    return (
        <ComingSoonPanel
            title="販促分析"
            description="クーポン・キャンペーン別の売上・利益貢献を表示する想定です。"
        />
    );
};

export default PromotionPage;
